export default {
  paged: {
    select: 'id,isActive,type,name,fileTypeClassification,size',
    searchSelect: ['name'],
    orderBy: 'name',
  },
};
